import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99834 21.0037H4.99709C3.89206 21.0037 2.99625 20.1079 2.99625 19.0029V4.99708C2.99625 3.89205 3.89206 2.99625 4.99709 2.99625H16.0017C17.1067 2.99625 18.0025 3.89205 18.0025 4.99708V7.99833"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.773 15.1613L20.4565 18.2786C20.8985 18.6503 21.0964 19.2374 20.9696 19.8008C20.8428 20.3642 20.4126 20.81 19.854 20.9565C19.2954 21.1031 18.7017 20.9261 18.3146 20.4975L15.0493 16.902"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99792 7.99833H13.0004"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99792 12H8.99875"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9244 13.8618L11.4588 15.0293C11.1882 15.2464 11.0226 15.5684 11.0035 15.9148C10.9845 16.2613 11.1136 16.5995 11.3587 16.845L12.4742 17.9655C12.7172 18.2097 13.053 18.3384 13.397 18.3193C13.741 18.3002 14.0605 18.135 14.275 17.8654L15.4514 16.4018C15.7313 16.0541 16.0487 15.7384 16.3978 15.4604L17.8634 14.292C18.134 14.075 18.2995 13.7532 18.3186 13.4069C18.3377 13.0606 18.2086 12.7226 17.9635 12.4772L16.852 11.3557C16.609 11.1115 16.2732 10.9828 15.9292 11.0019C15.5852 11.021 15.2658 11.1862 15.0513 11.4558L13.8708 12.9204C13.5907 13.2678 13.2733 13.5835 12.9244 13.8618V13.8618Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9238 20.9837H11.923"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
